import { DefaultLocale, Locale, LocaleString } from "models/locale";

// use this to parse translation from cb stored locale string
export const parse = (
  localeString: Partial<LocaleString> | LocaleString | undefined,
  locale: Locale,
) => {
  if (!localeString) {
    return "";
  }

  return localeString[locale] || localeString[DefaultLocale] || "";
};

export const repair = (
  lstrRef: LocaleString,
  userLocale: Locale,
  orgLocales: Locale[],
) => {
  // default translatin
  const fallbackTranslation = lstrRef[userLocale] || Object.values(lstrRef)[0];
  orgLocales.forEach((locale) => {
    lstrRef[locale] = lstrRef[locale] || fallbackTranslation;
  });
};

export const createEmpty = (example: string, orgLocales: Locale[]) => {
  const lstr: any = {};
  orgLocales.forEach((l) => {
    lstr[l] = example;
  });
  return lstr as LocaleString;
};
